import { GenderType } from 'we-tree-api-client/v2';

export function isMasculine(gender: GenderType): boolean {
  return gender === GenderType.Male || gender === GenderType.Transmasculine;
}

export function isFeminine(gender: GenderType): boolean {
  return gender === GenderType.Female || gender === GenderType.Transfeminine;
}
